const config = {
    domain: app_process.env.APP_DOMAIN,
    clientId: app_process.env.APP_CLIENT_ID
};

export default config;